module.exports = __webpack_public_path__ + "static/media/Foodtopia_tablet.1f6f3e4c.jpg";